export const createFJStory = (fjStory) => {
  return (dispatch, getState, { getFirebase, getFirestore}) => {
    // make async call to database
    const firestore = getFirestore();
    const profile = getState().firebase.profile;
    const userId = getState().firebase.auth.uid;

    firestore.collection('fjStories').add({
      // ...fjStory takes in the title and content properties
      ...fjStory, 
      userName: profile.userName,
      userID: userId,
      createdAt: new Date()
    }).then(() => {
      dispatch({ type: 'CREATE_FJS', fjStory: fjStory })
    }).catch((err) => {
      dispatch({ type: 'CREATE_FJS_ERROR', err })
    })
  }
}